// ROOT: frontend/src/components/Faq.jsx

import React, { useEffect, useState } from 'react';
import { FAQS } from '../mock';
import { Plus, Minus } from 'lucide-react';
import { api } from '../api';

const replaceBrand = (text, brandName) => {
  if (!text) return '';
  return text.replace(/\{\{brand\}\}/g, brandName);
};

const Faq = () => {
  const [open, setOpen] = useState(0);
  const [brandName, setBrandName] = useState('IGGrowth');
  const [contactEmail, setContactEmail] = useState('');

  useEffect(() => {
    const loadSettings = async () => {
      try {
        const settings = await api.getPublicSettings();

        setBrandName(
          settings?.brandName ||
          settings?.brand_name ||
          'IGGrowth'
        );

        setContactEmail(
          settings?.contactEmail ||
          settings?.contact_email ||
          ''
        );
      } catch (error) {
        console.error('Failed to load FAQ settings:', error);
      }
    };

    loadSettings();
  }, []);

  return (
    <section id="products" className="py-24">
      <div className="max-w-3xl mx-auto px-5 lg:px-8">

        <div className="text-center mb-12">
          <p className="text-sm font-bold tracking-widest uppercase plixy-gradient-text">
            FAQ
          </p>

          <h2 className="mt-3 text-4xl md:text-5xl font-extrabold text-[#0a1930]">
            Frequently Asked Questions
          </h2>

          <p className="mt-3 text-slate-600">
            Can't find what you're looking for?{' '}
            {contactEmail ? (
              <>
                Email us at{' '}
                <a
                  className="underline font-semibold"
                  href={`mailto:${contactEmail}`}
                >
                  {contactEmail}
                </a>
              </>
            ) : (
              'Contact us for more information.'
            )}
          </p>
        </div>

        <div className="space-y-3">
          {FAQS.map((item, index) => {
            const isOpen = open === index;

            const question = replaceBrand(item.q, brandName);
            const answer = replaceBrand(item.a, brandName);

            return (
              <div
                key={index}
                className="border border-slate-200 rounded-2xl overflow-hidden bg-white"
              >
                <button
                  type="button"
                  onClick={() => setOpen(isOpen ? -1 : index)}
                  className="w-full flex items-center justify-between gap-5 px-6 py-5 text-left"
                >
                  <span className="text-base md:text-lg font-bold text-[#0a1930]">
                    {question}
                  </span>

                  <span className="shrink-0 w-8 h-8 rounded-full bg-slate-50 flex items-center justify-center">
                    {isOpen ? (
                      <Minus className="w-4 h-4 text-[#0a1930]" />
                    ) : (
                      <Plus className="w-4 h-4 text-[#0a1930]" />
                    )}
                  </span>
                </button>

                {isOpen && (
                  <div className="px-6 pb-6">
                    <p className="text-slate-600 leading-7">
                      {answer}
                    </p>
                  </div>
                )}
              </div>
            );
          })}
        </div>

      </div>
    </section>
  );
};

export default Faq;
